export default class Constants {
  static BasePageSegment = 'document-centre';
  static BasePagePath = `/${Constants.BasePageSegment}`;
}
